define.alias("shared/components/shared/social/instagram-upgrade/modal", "calendar/components/shared/social/instagram-upgrade/modal");